import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  HostListener,
  ViewChild,
  TemplateRef,
  OnDestroy
} from '@angular/core';
import { find } from 'lodash';
import { AuthenticationService, GlobalInfoService, Logger } from '@app/core';
import {
  UsuarioActual,
  Const,
  Tarea,
  GlobalInfo,
  InformacionTramiteTarea,
  ModeloBase,
  BaseControl,
  DataIniciarSecundaria,
  ConfirmComponent,
  Context
} from '@app/shared';
import { environment } from '@env/environment';
import { HeaderTitleTaskDataService } from './shared/header-title-task.data.service';
import { HeaderTitleTaskFormService } from './shared/header-title-task.form.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';

const log: Logger = new Logger('HeaderTitleTaskComponent');

@Component({
  selector: 'iw-header-title-task',
  templateUrl: './header-title-task.component.html',
  styleUrls: ['./header-title-task.component.scss'],
  providers: [HeaderTitleTaskDataService, HeaderTitleTaskFormService]
})
export class HeaderTitleTaskComponent implements OnInit, OnDestroy {
  // Datos de la tarea
  @Input() task: Tarea;
  // tipo del proceso de la tarea renderizada
  @Input() typeProcess: string;
  // Contexto del formulario, es suministrado dinámicamente
  @Input() ctx: Context;
  // Evento para finalizar y cerrar la modal, es suministrado dinámicamente
  @Input() event: EventEmitter<any>;
  // Define cuando es el titulo de una tarea de asignacion
  @Input() assignament = false;
  // Contiene el usuario en sesion
  user: UsuarioActual;
  // Define si el usuario es responsable de la tarea
  userResponsible = false;
  // Define si la tarea esta activa
  taskActive = false;
  // Activa el modulo de carga de datos
  activateDataLoad = false;
  // Define si la tarea es una asignacion
  assignment = false;
  // Define si activa el boton de secundarias
  secondary = environment.secondary;
  // Define si activa el boton de secundarias para el tramite
  secondary_procedure = false;
  // Contiene lo controles de el formulario para iniciar secundaria
  controls: BaseControl<any>[] = [];
  // Contiene los procesos secundarios que se pueden iniciar
  secondarys: Array<ModeloBase> = [];
  // Referencia de la modal
  private modalRef: BsModalRef;
  // Contiene el tramite de la tarea actual
  private _tramite: InformacionTramiteTarea;
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Componente de confirmaciones
  @ViewChild(ConfirmComponent) confirmRef: ConfirmComponent;
  // Referencia del control personalizado para el select de tipos
  @ViewChild('selectSecondary') private selectSecondary: TemplateRef<any>;
  // Referencia de la modal de secundarias
  @ViewChild('modalSecondary') private modalSecondary: TemplateRef<any>;
  // Referencia de la modal de asignaciones de tarea
  @ViewChild('modalAsignament') private modalAsignament: TemplateRef<any>;
  // Variable de salida del evento
  @Output() response: EventEmitter<boolean> = new EventEmitter();
  // Salida del evento que determina si el usuario es responsable de la tarea
  @Output() responsibleTask: EventEmitter<boolean> = new EventEmitter();
  // Salida del evento que indica que un proceso secundario fue iniciado
  @Output() startSecondary: EventEmitter<DataIniciarSecundaria> = new EventEmitter();
  // Notifica la actualizacion de informacion de la tarea
  @Output() updateTask: EventEmitter<Partial<Tarea>> = new EventEmitter();

  constructor(
    private gis: GlobalInfoService,
    private as: AuthenticationService,
    private httds: HeaderTitleTaskDataService,
    private httfs: HeaderTitleTaskFormService,
    private modalService: BsModalService,
    private toastr: ToastrService,
  ) { }

  ngOnInit() {
    this.activateDataLoad = this.as.confirmPermission(
      Const.types_permissions.instanceProcess,
      Const.types_action_permissions.dataLoad,
    );
    // Consultar información global
    this.gis.get().subscribe(global => {
      this.setTramite(global);
    });
    // Obtener usuario autenticado
    this.user = this.as.getCredentials();
    if (this.task && this.task.responsables && this.task.responsables.length) {
      if (this.user) {
        const existUserResponsable = find(this.task.responsables, {id: this.user.user_id});
        if (existUserResponsable) {
          this.responsibleTask.emit(true);
          this.userResponsible = true;
        } else {
          this.responsibleTask.emit(false);
        }
      } else {
        this.responsibleTask.emit(false);
      }
    } else {
      this.responsibleTask.emit(false);
    }
    if (
      this.task.tarea_estado.nombre !== Const.STATUS_TASK.finished &&
      this.task.tarea_estado.nombre !== Const.STATUS_TASK.secondaryProgress
    ) {
      this.taskActive = true;
    }
    if (this.task.tarea_tipo.nombre === Const.TYPES_TASK.assignment) {
      this.assignment = true;
      this.activateDataLoad = false;
    }
    if(this.secondary == true){
      this.httds.consultSecondary(this.tramite.id).subscribe(data => {
        this.secondarys = data;
        if(data.length){
          this.secondary_procedure = true;
        };
      });
    }
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  get tramite(): InformacionTramiteTarea {
    return this._tramite;
  }

  /**
   * Le da el valor al tramite de la tarea actual
   *
   * @param {Partial<GlobalInfo>} global
   * @memberof DynamicComponentForm
   */
  setTramite(global: Partial<GlobalInfo>) {
    if (global.flowsHistory && global.flowsHistory.length) {
      this._tramite = {
        id: global.flowsHistory[0],
        id_proceso_actual: global.flow.id,
        nombre: global.title,
        descripcion: global.flow.descripcion
      };
    }
  }

  /**
   * Reacciona al evento de soltar una tecla.
   *
   * @param {*} e
   * @memberof HeaderTitleTaskComponent
   */
  @HostListener('window:keyup', ['$event'])
  onKeyUp(e: any) {
    switch (e.keyCode) {
      // Escape
      case 27:
        this.close();
        break;
    }
  }

  /**
   * Emite el evento de cerrar la tarea
   *
   * @memberof HeaderTitleTaskComponent
   */
  close(): void {
    this.response.emit(true);
  }

  /**
   * Abre la modal de las secundarias que se pueden iniciar en el estado del tramite
   *
   * @memberof HeaderTitleTaskComponent
   */
  openModalSecondary() {
    this.controls = this.httfs.getFields(this.selectSecondary);
    this.openModal(this.modalSecondary);
  }

  /**
   * Se encarga de notificar al componente padre que se desea iniciar una secundaria
   *
   * @param {*} data
   * @memberof HeaderTitleTaskComponent
   */
  sended(data: any) {
    this.confirmRef.new({
      question: '¿Esta seguro de iniciar un proceso secundario?',
      labelConfirm: 'si',
      labelDecline: 'no'
    })
    .then(async res => {
      if (res) {
        if (data.cboSecondary) {
          const dataForm: DataIniciarSecundaria = {
            id: data.cboSecondary,
            tarea_id: this.task.id
          };
          this.modalRef.hide();
          this.startSecondary.emit(dataForm);
        } else {
          this.toastr.warning('Debe seleccionar una secundaria', 'Información incompleta');
        }
      }
    });
  }

  /**
   * Iniciar carga de datos
   *
   * @memberof HeaderTitleTaskComponent
   */
  initDataLoad() {
    this.confirmRef.new({
      question: '¿Realmente desea iniciar la carga de datos?',
      labelConfirm: 'Sí',
      labelDecline: 'No'
    }).then(res => {
      if (res) {
        this.httds.initDataLoad(this.task.id).subscribe(resp => {
          if (resp) {
            this.task.carga = true;
            this.updateTask.emit({carga: true});
          }
        });
      }
    });
  }

  /**
   * Terminada la finalizacion de carga de datos se procede a refrescar el flujo
   *
   * @memberof HeaderTitleTaskComponent
   */
  finishDataLoadRefresh() {
    this.modalRef.hide();
    this.event.emit({
      type: 'refreshFlow',
    });
    this.event.emit({
      type: 'closeForm',
    });
  }

  /**
   * Abre una modal en la vista
   *
   * @private
   * @param {TemplateRef<any>} template
   * @param {boolean} [ignoreBackdropClick=true]
   * @param {string} [classModal='modal-lg']
   * @memberof HeaderTitleTaskComponent
   */
  private openModal(template: TemplateRef<any>, ignoreBackdropClick: boolean = true, classModal: string = 'modal-lg') {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: classModal, ignoreBackdropClick: ignoreBackdropClick })
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/forms/shared/header-title-task/header-title-task.component.ts